import React from 'react';

import { Provider, inject, observer } from 'mobx-react';

import {Sentry} from './components/shared';
import Routes from './core/Routes';
import stores from './stores';

class App extends React.Component {
    compoenntDidMount() {
        this.props.core.fetch();
    }
    render() {
        return (<Routes/>);
    };
}

const DecoratedApp = inject('core')(observer(App));

export default () => (
    <Sentry>
        <Provider {...stores}>
            <DecoratedApp />
        </Provider>
    </Sentry>
);
